import { render, staticRenderFns } from "./RetencionListado.vue?vue&type=template&id=3f4c86ca&scoped=true"
import script from "./RetencionListado.vue?vue&type=script&lang=js"
export * from "./RetencionListado.vue?vue&type=script&lang=js"
import style0 from "./RetencionListado.vue?vue&type=style&index=0&id=3f4c86ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c86ca",
  null
  
)

export default component.exports